import { Theme } from "@mui/material";

const cookiePolicyStyle = {
  cookiePolicy: (theme: Theme) => ({
    margin: "2rem 0",
    [theme.breakpoints.up("md")]: {
      margin: "5rem 0",
    },
  }),
  headline: {
    hyphens: "auto",
  },
  tableHeadCell: {
    backgroundColor: "primary.main",
    color: "#fff",
  },
  tableBodyCell: {
    verticalAlign: "top",
  },
  tableBodyCellContent: {
    verticalAlign: "top",
    width: "50%",
  },
  preferenceLink: {
    textAlign: "right",
    margin: "2rem 0",
  },
};

export default cookiePolicyStyle;
